<div class="row">
  <div class="col-12">
    <h4 class="mt-0 text-center text-md-left" translate>SECURITY</h4>
    <hr>
  </div>
  <div class="col-12">
    <lib-inactive-users-notification-configuration></lib-inactive-users-notification-configuration>
  </div>
</div>
